import { createReducer, updateState } from "redux/handlers"
import types from './types'

const initialState = {
  category: null
}

const categoriesEvent = (state, action) => {
  return updateState(state, { category: action.category })
}

export default createReducer(initialState, {
  [types.CATEGORIES_EVENT]: categoriesEvent,
})